import { combineReducers } from "redux";
import FoldersReducer from "./FoldersReducer";

const BookmarksReducer = combineReducers({ folders: FoldersReducer });
export default BookmarksReducer;
